import React from 'react';
import './Projects.css';
import webtoonScreenshot from './images/webtoon translator demo screenshot.png';

const Projects = () => {
  return (
    <div className="projects">
      <div className="notion-page">
        <div className="notion-page-header">
          <h1 className="notion-page-title">Projects</h1>
        </div>
      </div>

      <div className="projects-grid">
        <div className="notion-callout project-card" style={{ position: 'relative' }}>
          <span className="notion-callout-icon">🌱</span>
          <div className="notion-callout-content">
            <h3 style={{ fontSize: '18px', fontWeight: 'var(--font-weight-semibold)', marginBottom: '8px' }}>Sprig</h3>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              React, Flask, Dedalus MCP, OpenAI, Gemini
            </p>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '12px' }}>
              Built a sustainable cooking assistant scanning fridge images to auto-generate ingredient lists and recipes. Integrated GPT-powered ingredient extraction, Gemini recipe generation, and sustainability-based store suggestions. Developed full-stack pipeline using React, Flask, and MCP agents for search and sentiment analysis.
            </p>
            <div style={{ marginTop: '12px', marginBottom: '12px', position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: 'var(--radius)' }}>
              <iframe
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
                src="https://www.youtube.com/embed/ts2rNXE_EYk"
                title="Sprig Demo Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '8px' }}>
              <a href="https://devpost.com/software/sprig-j7nft8?ref_content=my-projects-tab&ref_feature=my_projects" target="_blank" rel="noopener noreferrer" className="project-link">Devpost</a>
              <span style={{ color: 'var(--text-secondary)' }}>|</span>
              <a href="https://github.com/EricFor/Sprig" target="_blank" rel="noopener noreferrer" className="project-link">GitHub</a>
            </div>
          </div>
        </div>

        <div className="notion-callout project-card" style={{ position: 'relative' }}>
          <span className="notion-callout-icon">🔬</span>
          <div className="notion-callout-content">
            <h3 style={{ fontSize: '18px', fontWeight: 'var(--font-weight-semibold)', marginBottom: '8px' }}>Y/Labs</h3>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              MERN stack and TypeScript
            </p>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              A portfolio and community platform showcasing Yale labs. Designed and built frontend features to improve site usability and visual appeal.
            </p>
            <div style={{ marginTop: '12px', marginBottom: '12px', position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: 'var(--radius)' }}>
              <iframe
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
                src="https://www.youtube.com/embed/Crf3Tyjsk2k"
                title="Y/Labs Demo Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '8px' }}>
              <a href="https://yalelabs.io" target="_blank" rel="noopener noreferrer" className="project-link">Live Site</a>
              <span style={{ color: 'var(--text-secondary)' }}>|</span>
              <a href="https://github.com/YaleComputerSociety/ylabs" target="_blank" rel="noopener noreferrer" className="project-link">GitHub Repo</a>
              <span style={{ color: 'var(--text-secondary)' }}>|</span>
              <a href="https://www.youtube.com/watch?v=Crf3Tyjsk2k" target="_blank" rel="noopener noreferrer" className="project-link">Demo Video</a>
            </div>
          </div>
        </div>

        <div className="notion-callout project-card" style={{ position: 'relative' }}>
          <span className="notion-callout-icon">🚗</span>
          <div className="notion-callout-content">
            <h3 style={{ fontSize: '18px', fontWeight: 'var(--font-weight-semibold)', marginBottom: '8px' }}>Yideshare</h3>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              Prisma, Next.js, and Tailwind
            </p>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              A Yale rideshare website that allows students to post and find rides to and from Yale.
            </p>
            <div style={{ marginTop: '12px', marginBottom: '12px', position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: 'var(--radius)' }}>
              <iframe
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
                src="https://www.youtube.com/embed/boGjt1DxaX8"
                title="Yideshare Demo Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '8px' }}>
              <a href="https://yideshare.com" target="_blank" rel="noopener noreferrer" className="project-link">Live Site</a>
              <span style={{ color: 'var(--text-secondary)' }}>|</span>
              <a href="https://www.youtube.com/watch?v=boGjt1DxaX8" target="_blank" rel="noopener noreferrer" className="project-link">Demo Video</a>
            </div>
          </div>
        </div>

        <div className="notion-callout project-card" style={{ position: 'relative' }}>
          <span className="notion-callout-icon">📖</span>
          <div className="notion-callout-content">
            <h3 style={{ fontSize: '18px', fontWeight: 'var(--font-weight-semibold)', marginBottom: '8px' }}>Webtoon Translator</h3>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              Python, OpenCV, EasyOCR, OpenAI API
            </p>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '12px' }}>
              An AI-powered tool that instantly translates webtoon panels. Upload your webtoon panel and get an instant translation. Built Korean-to-English webtoon translation pipeline with OCR, LLM translation, and image inpainting. Implemented panel splitting, text removal, sound-effect mapping, and translation caching. Achieved accurate text detection and context-aware dialogue rewriting.
            </p>
            <div style={{ marginTop: '12px', marginBottom: '12px', borderRadius: 'var(--radius)', overflow: 'hidden' }}>
              <img src={webtoonScreenshot} alt="Webtoon Translator Demo" style={{ width: '100%', height: 'auto', display: 'block' }} />
            </div>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '8px' }}>
              <a href="https://github.com/cphanhth/Webtoon-Translator" target="_blank" rel="noopener noreferrer" className="project-link">GitHub Repository</a>
            </div>
          </div>
        </div>

        <div className="notion-callout project-card" style={{ position: 'relative' }}>
          <span className="notion-callout-icon">💝</span>
          <div className="notion-callout-content">
            <h3 style={{ fontSize: '18px', fontWeight: 'var(--font-weight-semibold)', marginBottom: '8px' }}>YCrush</h3>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              MongoDB, Express, React, Node
            </p>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '12px' }}>
              A dating app that allows Yale students to swipe left or right on potential matches. Developed Yale dating platform with profile browsing, matching, and full chat system. Built UI with Tailwind + React Router for dynamic transitions and reliable auth. Implemented fast profile pre-loading reducing load times by 300%.
            </p>
            <div style={{ marginTop: '12px', marginBottom: '12px', position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: 'var(--radius)' }}>
              <iframe
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
                src="https://www.youtube.com/embed/TaP5CwlMwrA"
                title="YCrush Demo Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '8px' }}>
              <a href="https://ycrush.vercel.app/" target="_blank" rel="noopener noreferrer" className="project-link">Live Site</a>
              <span style={{ color: 'var(--text-secondary)' }}>|</span>
              <a href="https://www.youtube.com/watch?v=TaP5CwlMwrA" target="_blank" rel="noopener noreferrer" className="project-link">Demo Video</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
